import type { Router } from 'vue-router'
import { useMainStore } from '@/stores/ui/main'
import { useNotificationStore } from '@/stores/ui/notifications'

// The backend refuses to pay for a trip whose date has passed with a 422 (Order::TRIP_DATE_PASSED_MESSAGE):
// transaction/init, the payment page data, and the PATCH that picks a car or follows a mail_car link.
// A plain 422 is also what form validation answers with, so the message is matched too.
export const TRIP_DATE_PASSED_API_MESSAGE = 'The trip date has already passed'

export const TRIP_DATE_PASSED_MESSAGE =
  'The date of this trip has already passed, so it can no longer be paid. Please create a new booking or contact us.'

export const isTripDatePassed = (error: unknown): boolean => {
  const response = (
    error as { response?: { status?: number; data?: { message?: string } } } | undefined
  )?.response

  return response?.status === 422 && response.data?.message === TRIP_DATE_PASSED_API_MESSAGE
}

// Shows the message when the error is that refusal. Returns true when it did, so the caller can
// stop there and keep its own handling for every other error.
export const notifyIfTripDatePassed = (error: unknown): boolean => {
  if (!isTripDatePassed(error)) {
    return false
  }
  useNotificationStore().showError(TRIP_DATE_PASSED_MESSAGE)
  return true
}

// The whole answer to that refusal for the calls that lead to the payment (the car PATCH, the
// mail_car link): tell the customer, stop the loader and take them to the home page — there is
// nothing left to do with this booking. Returns true when it handled the error, so the caller
// can stop there and keep its own handling for every other error.
export const handleTripDatePassed = (error: unknown, router: Router): boolean => {
  if (!notifyIfTripDatePassed(error)) {
    return false
  }
  useMainStore().isRequesting = false
  router.push({ name: 'home' })
  return true
}
